"use client";

import { useEffect, useState } from "react";
import HomeSections from "./HomeSections";
import HomepageSkeleton from "./HomepageSkeleton";
export default function LazyHomeSections() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    async function loadSections() {
      setLoading(true);
      try {
        const res = await fetch('/api/home/sections');
        const data = await res.json();
        setSections(data?.hsections || []);
      } catch (error) {
        setSections([]);
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    loadSections();
  }, []);
  if (loading) {
    return <div className={'py-10 text-center'}>
                <HomepageSkeleton />
            </div>;
  }
  return <HomeSections sections={sections} />;
}